export const calculateContractorOwner1099 = (payload, taxInformationData) => {
  const nextPayload = { ...payload };

  const grossReceipts = parseFloat(nextPayload["Gross Monthly Wages"] || 0);
  const returns = parseFloat(nextPayload["Returns & Allowances"] || 0);
  const cogs = parseFloat(nextPayload["Cost of Goods Sold (COGS)"] || 0);

  // Gross Profit = Gross Receipts - Returns - COGS
  const grossProfit = grossReceipts - returns - cogs;
  nextPayload["Gross Profit"] = grossProfit;

  const homeOffice = parseFloat(nextPayload["Home Office Deduction"] || 0);
  const vehicle = parseFloat(nextPayload["Vehicle Mileage"] || 0);
  const advertising = parseFloat(nextPayload["Advertising"] || 0);
  const travel = parseFloat(nextPayload["Travel"] || 0);
  const contractLabor = parseFloat(nextPayload["Contract Labor"] || 0);

  // Total Expenses (Operating Expenses) = sum of individual fields found in JSON
  const totalOperatingExpenses = homeOffice + vehicle + advertising + travel + contractLabor;
  nextPayload["Total Expenses"] = totalOperatingExpenses;

  // Net Business Profit = Gross Profit - Total Operating Expenses
  const netBusinessProfit = grossProfit - totalOperatingExpenses;
  nextPayload["Net Business Profit"] = netBusinessProfit;

  // Estimated SE Tax Liability = (Net Business Profit x 0.9235) x 15.3%
  const seTaxLiability = parseFloat(((netBusinessProfit * 0.9235) * 0.153).toFixed(2));
  nextPayload["Estimated Self Employment Tax Liability"] = seTaxLiability;

  // Amount Subject to Tax Correction Formula:
  // 1. Start with Net Business Profit
  // 2. Subtract SE Health Premiums
  // 3. Subtract Retirement Contributions (SEP / Solo 401k)
  // 4. Subtract 1/2 of SE Tax Liability
  // 5. Subtract QBI Deduction (Higher of 20% of Profit or $400 Floor)
  const seHealthPremiums = parseFloat(nextPayload["Self Employment Health Insurance Premiums"] || 0);
  const retirementContrib = parseFloat(nextPayload["Retirement Plan (SEP / Solo 401k)"] || 0);
  
  // QBI Calculation for 2026 (OBBBA Rules)
  const qbi20Percent = netBusinessProfit * 0.20;
  const qbiFloor = netBusinessProfit >= 1000 ? 400 : 0;
  const actualQbiDeduction = Math.max(qbi20Percent, qbiFloor);

  const amountSubjectToTax = netBusinessProfit - seHealthPremiums - retirementContrib - (seTaxLiability / 2) - actualQbiDeduction;
  nextPayload["Amount Subject to Tax"] = parseFloat(amountSubjectToTax.toFixed(2));

  // Minimum QBI Deduction (2026 Floor) - display the floor value
  nextPayload["Minimum QBI Deduction (2026 Floor)"] = qbiFloor;

  return nextPayload;
};

export const getContractorOwner1099Config = (name) => {
  const config = {
    "Gross Monthly Wages": { label: "Gross Receipts or Sales" },
    "Estimated Annual Business Expenses": { delete: true },
    "Gross Profit": { readOnly: true },
    "Total Expenses": { label: "Total Operating Expenses", readOnly: true },
    "Estimated Self Employment Tax Liability": { readOnly: true },
    "Minimum QBI Deduction (2026 Floor)": { readOnly: true },
    "Adjusted Gross Income (AGI)": { delete: true },
    "Amount Subject to Tax": { readOnly: true },
    "Net Business Profit": { readOnly: true },
    "Adjusted Gross Income (AGI) Toggle": { delete: true },
  };
  return config[name] || {};
};

export const getContractorOwner1099GroupPrefix = (groupName) => {
  if (groupName === "Cost of Goods Sold (COGS)") return "Part B: Revenue & Direct Costs (COGS) - ";
  if (groupName === "Operating Expenses") return "Part C: Operating Expenses (The \"P&L\" Section) - ";
  if (groupName === "Self Employment Benefits and Taxes") return "Part D: ";
  if (groupName === "Advanced QBI Data (The 199A Engine)") return "Part E: ";
  return "";
};
